import * as React from 'react';
import {
  AmuStaffOutlined,
  AmuFolderOutlined,
  AmuEnterpriseOutlined,
  TeamOutlined,
  AmuGroupOutlined,
  AmuAdministratorOutlined,
} from '@cloud/atom-ui-icons';

export default {
  // 需要用到的Icon组件数组，需要提前引入
  AmuStaffOutlined: <AmuStaffOutlined />,
  AmuFolderOutlined: <AmuFolderOutlined />,
  AmuEnterpriseOutlined: <AmuEnterpriseOutlined />,
  TeamOutlined: <TeamOutlined />,
  AmuGroupOutlined: <AmuGroupOutlined />,
  AmuAdministratorOutlined: <AmuAdministratorOutlined />,
};
